import { lazy } from "react";
import Loadable from "../../components/Loadable";
import { TASKLIST, NEWTASK ,PROJECTTASK,ADDPROJECT,PROJECTLIST, TASKSTATUS, MYTASK } from "../../utils/constant";


// Lazy load your pages
const TaskList = Loadable(lazy(() => import("./TaskList")));
const NewTask = Loadable(lazy(() => import("./NewTask")));
const ProjectTask = Loadable(lazy(() => import("./ProjectTask")));
const AddProject = Loadable(lazy(() => import("./AddProject")));
const ProjectList = Loadable(lazy(() => import("./ProjectList")));
const TaskStatus = Loadable(lazy(() => import("./TaskStatus")));
const MyTask = Loadable(lazy(() => import("./MyTask")));
const taskManagementRoute = [
  {
    path: "/taskmanagement/TaskList/:projectId",
    element: <TaskList />,
    permission: TASKLIST,
  },
  {
    path: "/taskmanagement/addTask/:projectId",
    element: <NewTask />,
    permission: NEWTASK,
  },
  {
    path: "/taskmanagement/ProjectTask",
    element: <ProjectTask />,
    permission:PROJECTTASK  ,
  },

{
  path: "/taskmanagement/AddProject",
  element: <AddProject />,
  permission: ADDPROJECT, 
},
{ path: "/taskmanagement/ProjectList",
  element: <ProjectList />,
  permission: PROJECTLIST, 
},
{
  path: "/taskmanagement/TaskStatus",
  element: <TaskStatus />,
  permission: TASKSTATUS,
},
{
  path: "/taskmanagement/MyTask",
  element: <MyTask />,
  permission: MYTASK,
}
];

export default taskManagementRoute;
